import React from "react";
import { Link } from "react-router-dom";
import { useLang, usePerm } from "../lib/providers";
import { FileText, Ruler } from "@phosphor-icons/react";

/**
 * Tab bar for "Angebote / Aufmaße" inside the sales workflow.
 * VAT settings are managed under Einstellungen → Mehrwertsteuer-Sätze, not here.
 */
export default function QuotesTabBar({ active }) {
  const { lang } = useLang();
  const { can } = usePerm();
  const canViewAufmasse = can("aufmasse", "view");

  const cls = (isActive) =>
    `px-4 py-2 text-sm font-medium border-b-2 -mb-px inline-flex items-center gap-1.5 transition-colors ${
      isActive
        ? "border-[var(--brand)] text-[var(--brand)]"
        : "border-transparent text-[var(--muted)] hover:text-[var(--ink)]"
    }`;

  // If aufmaße permission is missing the tab bar is pointless — hide entirely.
  if (!canViewAufmasse) return null;

  return (
    <div className="flex gap-2 mb-6 border-b border-[var(--border)] overflow-x-auto">
      {active === "quotes" ? (
        <span className={cls(true)} data-testid="tab-quotes-active">
          <FileText size={14} /> {lang === "de" ? "Angebote" : "Quotes"}
        </span>
      ) : (
        <Link to="/quotes" className={cls(false)} data-testid="tab-quotes">
          <FileText size={14} /> {lang === "de" ? "Angebote" : "Quotes"}
        </Link>
      )}

      {active === "aufmasse" ? (
        <span className={cls(true)} data-testid="tab-aufmasse-active">
          <Ruler size={14} /> {lang === "de" ? "Aufmaße" : "Measurements"}
        </span>
      ) : (
        <Link to="/aufmasse" className={cls(false)} data-testid="tab-aufmasse">
          <Ruler size={14} /> {lang === "de" ? "Aufmaße" : "Measurements"}
        </Link>
      )}
    </div>
  );
}
